import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="employment-form"
export default class extends Controller {
  static targets = ["endDateContainer", "departureReasonsContainer", "departureFormTemplate", "departures", "status"]
  static classes = ["hidden"]

  connect() {
    this.originalStatus = this.getStatus();
  }

  getStatus() {
    return this.statusTargets.find(radio => radio.checked).value;
  }

  isEmployed() {
    return this.getStatus() === "employed"
  }

  handleStatusChange() {
    this.endDateContainerTarget.classList.toggle(this.hiddenClass, this.isEmployed())
    this.departureReasonsContainerTarget.classList.toggle(this.hiddenClass, this.isEmployed())
  }

  resetStatus() {
    // Find the radio button that matches the original status and check it
    const originalStatusRadio = this.statusTargets.find(radio => radio.value === this.originalStatus);
    if (originalStatusRadio) {
      originalStatusRadio.checked = true;
    }
    this.handleStatusChange();
  }

  clearDepartureFieldsIfEmployed(event) {
    if (!this.isEmployed()) {
      return;
    }

    if (this.originalStatus !== 'employed') {
      const confirmation = confirm('Changing status to employed will delete all employment departures. Are you sure?');

      if (!confirmation) {
        event.preventDefault();
        this.resetStatus();
        return;
      }
    }
  }

  addDeparture(event) {
    event.preventDefault
    let dummy = new Date().getTime()
    let content = this.departureFormTemplateTarget.innerHTML.replace(/NEW_RECORD/g, dummy.toString())
    this.departuresTarget.insertAdjacentHTML('beforeend', content)
  }
}
